document.addEventListener('DOMContentLoaded', function () {

	// Format the price above to USD using the locale, style, and currency.
	let rubFormat = new Intl.NumberFormat('ru-RU', {
		style: 'currency',
		currency: 'RUB',
		minimumFractionDigits: 0,
	});

	// Fancybox.bind("#dialog-tinkoff-widget", {
	// 	on: {
	// 		close: (fancybox, slide) => {
	// 			console.log('asdasdasdasdasd!');

	// 			document.getElementById("payform-tinkoff").reset();
	// 		},
	// 	},
	// });

	// Обработчик промокода
	const promocodeHandler = function (e) {
		// result.innerText = e.target.value;
		let promocodeInputField = e.target
		let tinkoffModal = e.target.closest('.tinkoff-modal-form'); // Получаем модальную форму
		let tinkoffForm = e.target.closest("#payform-tinkoff"); // Получаем форму Тинькова
		let amount_full = tinkoffForm.querySelector('#amount_full').value
		let promocode = e.target.value // Введенный промокод

		promocode = promocode.trim().toLowerCase(); // Ощищаем пробелы в начале и конце строки и приводим все в нижний регистр
		console.log('PROMOCODE', promocode)

		const promocodes = {
			// 'promo1': 7, // 7% скидка
			// 'promo2': 7, // 7% скидка
			// 'promo3': 7, // 7% скидка
			// 'promo4': 7, // 7% скидка
			// 'promo5': 7, // 7% скидка
			'мэкспа1': 7,
			'мэкспа2': 7,
			'мэкспа3': 7,
			'мэкспа4': 7,
			'мэкспа5': 7,
		}

		// Если промокод введен правильно
		if (promocodes.hasOwnProperty(promocode)) {
			console.log('Применяем промокод', promocode)

			promocodeInputField.classList.remove('promocode-invalid')
			promocodeInputField.classList.add('promocode-valid') // добавляем класс

			let price = tinkoffForm.querySelector('#amount_full').value // получаем текущую цену
			let amountPromo = price - Math.floor(price) / 100 * Number(promocodes[promocode]) // вычисляем цену со скидкой
			// document.getElementById('amount_promo').value = amountPromo // устанавливаем цену со скидкой

			console.log('tinkoffForm', tinkoffForm);

			tinkoffForm.querySelector('#amount_promo').value = amountPromo // устанавливаем цену со скидкой

			// let amountPromo = document.getElementById('amount_promo').value

			tinkoffForm.querySelector('#amount').value = amountPromo
			tinkoffModal.querySelector('#form-price-string').textContent = rubFormat.format(amountPromo);

			// Показываем старую цену
			tinkoffModal.querySelector('#form-old-price').textContent = rubFormat.format(amount_full);
			tinkoffModal.querySelector('#form-old-price').style.display = 'block';

			// Добавляем промокод в описание платежной формы
			let tformDescription = tinkoffForm.querySelector('#description');
			// if (!tformDescription.value.indexOf(promocode)) {
			tformDescription.value += ` (промокод: ${promocode})`;
			// }

		} else {
			// Если промокод не сработал
			promocodeInputField.classList.add('promocode-invalid')
			promocodeInputField.classList.remove('promocode-valid')

			let price = document.getElementById('amount').value
			document.getElementById('amount').value = amount_full
			document.getElementById('form-price-string').textContent = rubFormat.format(amount_full);
			// document.getElementById('amount').value = amountPromo
			// document.getElementById('form-price-string').textContent = rubFormat.format(amountPromo);
			document.getElementById('form-old-price').style.display = 'none';

		}
	}

	// Клик по кнопке заказать
	function changePrice(o) {
		// Обновляем форму
		document.getElementById('payform-tinkoff').reset();

		// Принудительно вызываем событие обновления инпута с промо
		var promocodeInput = document.getElementById('promocode');
		var changeEvent = new Event('change');
		promocodeInput.dispatchEvent(changeEvent);

		price = o.dataset.price
		promoPrice = o.dataset.promo
		description = o.dataset.description

		document.getElementById('description').value = description;
		document.getElementById('amount').value = price;
		document.getElementById('amount_full').value = price; // Полная цена
		document.getElementById('amount_promo').value = promoPrice;

		// Заполняем подзаголовок формы
		document.getElementById('form-subtitle').innerHTML = 'Тариф: ' + description;

		document.getElementById('form-price-string').textContent = rubFormat.format(price);


	}


	const TPF = document.getElementById("payform-tinkoff");

	// const tariffButton = document.querySelector(".js-tariff-button");
	const tariffButtons = document.getElementsByClassName("js-tariff-button")

	Array.prototype.forEach.call(tariffButtons, function (tariffButton) {
		tariffButton.addEventListener("click", (e) => {
			// button.textContent = `Click count: ${event.detail}`;
			let target = e.target || e.srcElement,
				text = target.textContent || target.innerText;
			// console.log('click target', target);

			changePrice(target)
		});
	});

	// console.log('tariffButton', tariffButton);
	// tariffButton.addEventListener("click", (e) => {
	// 	// button.textContent = `Click count: ${event.detail}`;
	// 	let target = e.target || e.srcElement,
	// 		text = target.textContent || target.innerText;
	// 	console.log('click target', target);

	// 	changePrice(target)
	// });

	// Обработчик промокода
	// document.getElementById('promocode').addEventListener('change', promocodeHandler);
	document.getElementById('promocode').addEventListener('change', promocodeHandler);
	document.getElementById('promocode').addEventListener('keyup', function (event) {
		console.log('Нажата клавиша ' + event.key)
		promocodeHandler(event)
	})
	// document.getElementById('promocode').addEventListener("keypress", (e) => {
	// 	promocodeHandler(e)
	// })


	const validator = new JustValidate('#payform-tinkoff', {
		validateBeforeSubmitting: true,
	}); // Валидация

	validator
		// Публичная оферта
		.addField(
			'#public_offer_consent_checkbox',
			[
				{
					rule: 'required',
					errorMessage: 'Необходимо согласиться с публичной офертой',
				},
			],
			{
				errorsContainer: '#public_offer_consent_checkbox-errors-container',
			}
		)
		// Политика конфиденциальности
		.addField(
			'#privacy_policy_consent_checkbox',
			[
				{
					rule: 'required',
					errorMessage: 'Необходимо согласиться с политикой конфиденциальности',
				},
			],
			{
				errorsContainer: '#privacy_policy_consent_checkbox-errors-container',
			}
		)
		// Обработка персональных данных
		.addField(
			'#personal_data_consent_checkbox',
			[
				{
					rule: 'required',
					errorMessage: 'Необходимо согласиться с обработкой персональных данных',
				},
			],
			{
				errorsContainer: '#personal_data_consent_checkbox-errors-container',
			}
		)
		// Получение рассылок
		.addField(
			'#newsletter_consent_checkbox',
			[
				{
					rule: 'required',
					errorMessage: 'Необходимо согласиться с получением рассылок',
				},
			],
			{
				errorsContainer: '#newsletter_consent_checkbox-errors-container',
			}
		);

	TPF.addEventListener("submit", function (e) {
		e.preventDefault();
		const {
			description,
			amount,
			email,
			phone,
			receipt,
			public_offer_consent_checkbox,
			privacy_policy_consent_checkbox,
			personal_data_consent_checkbox,
			newsletter_consent_checkbox
		} = TPF;

		console.log('public_offer_consent_checkbox.checked', public_offer_consent_checkbox.checked);
		console.log('privacy_policy_consent_checkbox.checked', privacy_policy_consent_checkbox.checked);
		console.log('personal_data_consent_checkbox.checked', personal_data_consent_checkbox.checked);
		console.log('newsletter_consent_checkbox.checked', newsletter_consent_checkbox.checked);

		// Проверяем чекбоксы
		if (
			public_offer_consent_checkbox.checked
			&& privacy_policy_consent_checkbox.checked
			&& personal_data_consent_checkbox.checked
			&& newsletter_consent_checkbox.checked) {
			if (receipt) {
				if (!email.value && !phone.value)
					return alert("Поле E-mail или Phone не должно быть пустым");

				TPF.receipt.value = JSON.stringify({
					"EmailCompany": "mail@mail.com",
					"Taxation": "patent",
					"FfdVersion": "1.2",
					"Items": [
						{
							"Name": description.value || "Оплата",
							"Price": amount.value + '00',
							"Quantity": 1.00,
							"Amount": amount.value + '00',
							"PaymentMethod": "full_prepayment",
							"PaymentObject": "service",
							"Tax": "none",
							"MeasurementUnit": "pc"
						}
					]
				});
			}
			pay(TPF);
		}
	})

});
